import React, { Component } from 'react';
import { Table, Grid, Button, Icon, Popup } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import SearchTableData from '../util/SearchTableData';
import ReactExport from 'react-data-export';
import { sanitizeExcelDataSet } from '../util/sanitizeExcel';

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

class NonCycleStudentsTable extends Component {
    render() {
        const {
            students,
            filteredStudents,
            excelData,

            getResults,
            handleSearchTextChange,

            deletingRowId,
            saving,

            handleDeleteClick,
            handleConfirmClick,
            handleCancelClick,

            isAdmin,
            isStudentService,

            nonGradedWarnings,
        } = this.props;

        return (
            <Table celled selectable>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell colSpan={10}>
                            <Grid stackable verticalAlign="middle">
                                <Grid.Column width={14}>
                                    <SearchTableData
                                        profMozilla
                                        data={students}
                                        getResults={getResults}
                                        filterItem={['firstName', 'lastName']}
                                        onSearchTextChange={handleSearchTextChange}
                                    />
                                </Grid.Column>
                                <Grid.Column width={2} textAlign="right">
                                    <ExcelFile filename="Dolazne mobilnosti" element={<Popup
                                        trigger={<Button animated="vertical" color="green" basic
                                                         floated="right" fluid
                                                         style={{ textAlign: 'center' }}>
                                            <Button.Content hidden> <Icon
                                                name="download"/></Button.Content>
                                            <Button.Content visible>
                                                Excel
                                            </Button.Content>
                                        </Button>}
                                        content={<FormattedMessage id="externalStudent.downloadExcel"/>}
                                        hideOnScroll
                                        position="top center"
                                    />}>
                                        <ExcelSheet dataSet={sanitizeExcelDataSet(excelData)}
                                                    name="Studenti"/>
                                    </ExcelFile>

                                </Grid.Column>
                            </Grid>
                        </Table.HeaderCell>
                    </Table.Row>
                    <Table.Row>
                        <Table.HeaderCell colSpan={1}>
                            <FormattedMessage id="externalStudent.ordinalNumber"/>
                        </Table.HeaderCell>
                        <Table.HeaderCell colSpan={2}>{<FormattedMessage
                            id="externalStudent.fullName"/>}
                            <div style={{
                                fontSize: '0.85em',
                                color: '#999'
                            }}>{<FormattedMessage id="externalStudent.email"/>}</div>
                        </Table.HeaderCell>
                        <Table.HeaderCell colSpan={2}>{<FormattedMessage
                            id="externalStudent.programName"/>}
                        </Table.HeaderCell>
                        <Table.HeaderCell colSpan={2}>{<FormattedMessage
                            id="externalStudent.nonCycleStudyProgramType"/>}
                        </Table.HeaderCell>
                        <Table.HeaderCell colSpan={2}>{<FormattedMessage
                            id="externalStudent.programDurationMonths"/>} (ECTS)
                        </Table.HeaderCell>
                        <Table.HeaderCell width={1}/>
                    </Table.Row>
                </Table.Header>
                {filteredStudents.length > 0 ? (
                    <Table.Body>
                        {filteredStudents.map((student, index) => (
                            <Table.Row key={index}>
                                <Table.Cell>{index + 1}.</Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={2}>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                        <div style={{ flex: 1 }}>
                                            <div>{student.firstName} {student.lastName}
                                                {
                                                    (nonGradedWarnings && nonGradedWarnings.has(student.id)) &&
                                                    <Popup
                                                        content={
                                                            <div>
                                                                <FormattedMessage
                                                                    id={'externalStudent.nonGradedWarning'}/>
                                                                {nonGradedWarnings.get(student.id)
                                                                    .map((courseName, idx) => (
                                                                        <b key={idx}>
                                                                            <br/>
                                                                            {courseName}
                                                                        </b>
                                                                    ))
                                                                }
                                                            </div>
                                                        }
                                                        position="top center"
                                                        trigger={<Icon name="exclamation circle" color="yellow"
                                                                       style={{ marginLeft: '5px' }}/>}
                                                    />
                                                }
                                            </div>
                                            <div style={{
                                                fontSize: '0.85em',
                                                color: '#999'
                                            }}>
                                                {student.email}
                                            </div>
                                        </div>
                                        <span style={{ float: 'right', display: 'inline-flex', alignItems: 'center', gap: '6px', marginLeft: '8px' }}>
                                            {student.lockedAt && <Icon name="lock" color="blue"/>}
                                            {!student.lockedAt && student.dropoutDate &&
                                                <Icon name="sign-out" color="red"/>}
                                            {!student.lockedAt && student.graduationDate &&
                                                <Icon name="graduation cap" color="green"/>}
                                        </span>
                                    </div>
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={2}>
                                    <div>{student.nonCycleProgram ? student.nonCycleProgram.programName : '-'}</div>
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={2}>
                                    <div>{student.nonCycleProgram && student.nonCycleProgram.nonCycleStudyProgramType ? student.nonCycleProgram.nonCycleStudyProgramType.name : '-'}</div>
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={2}>
                                    <div>{student.nonCycleProgram ? student.nonCycleProgram.programDurationMonths : '-'} ({student.nonCycleProgram ? student.nonCycleProgram.maxEcts : '-'} ECTS)</div>
                                </Table.Cell>
                                {deletingRowId === student.id
                                    ?
                                    <Table.Cell textAlign="center" verticalAlign="middle" colSpan={1}>
                                        <Popup
                                            content={<FormattedMessage id="externalStudent.delete"/>}
                                            position="top center"
                                            trigger={<Button
                                                circular
                                                icon
                                                size="tiny"
                                                color="blue"
                                                onClick={handleConfirmClick}
                                                disabled={saving}
                                                loading={saving}
                                            >
                                                <Icon name="check"/>
                                            </Button>}/>
                                        <Popup
                                            content={<FormattedMessage id="externalStudent.cancel"/>}
                                            position="top center"
                                            trigger={<Button
                                                basic
                                                circular
                                                icon
                                                size="tiny"
                                                color="blue"
                                                onClick={handleCancelClick}
                                                disabled={saving}
                                            >
                                                <Icon name="close"/>
                                            </Button>}/>
                                    </Table.Cell>
                                    :
                                    <Table.Cell textAlign="center" verticalAlign="middle" colSpan={1}>
                                        <Popup
                                            content={<FormattedMessage
                                                id="externalStudent.studentProfile"/>}
                                            position="top center"
                                            trigger={
                                                <Button
                                                    as={Link}
                                                    to={{
                                                        pathname: '/neciklicni-studij/student',
                                                        state: { student }
                                                    }}
                                                    onClick={() => {
                                                        localStorage.setItem('nonCycleStudentId', student.id);
                                                    }}
                                                    size="small"
                                                    basic
                                                    circular
                                                    color={'blue'}
                                                    icon="user"
                                                    disabled={deletingRowId}
                                                />}
                                        />
                                        {(isAdmin || isStudentService)
                                            && <Popup
                                                content={<FormattedMessage
                                                    id="externalStudent.delete"/>}
                                                position="top center"
                                                trigger={<Button
                                                    basic
                                                    circular
                                                    icon
                                                    size="tiny"
                                                    color="red"
                                                    disabled={deletingRowId && deletingRowId !== student.id}
                                                    onClick={() => handleDeleteClick(student.id)}
                                                ><Icon name="trash alternate"/></Button>}
                                            />}
                                    </Table.Cell>
                                }
                            </Table.Row>
                        ))}
                    </Table.Body>) : (
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell colSpan={10} textAlign="left">
                                <FormattedMessage id="common.noDataToDisplay"/>
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                )
                }
            </Table>
        );
    }
}

export default NonCycleStudentsTable;



// WEBPACK FOOTER //
// ./src/views/NonCycleStudent/NonCycleStudentTable.js